import { ajax } from '@/api'

export default {
	queryparam( data ) {
	    const url = '/param/queryparam'
	    return ajax({ url, data, method: 'post' })
	},
}